import { useMemo } from 'react';

import { HEADLINE_TEXT, TRACK_VH } from 'constants/dnaHub';

import { DebugHud } from './DebugHud';
import styles from './DnaHub.module.scss';
import { useFrameSequence } from './useFrameSequence';

const isDebugEnabled = (): boolean =>
  typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('debug');

const DnaHub = (): JSX.Element => {
  const debugEnabled = useMemo(isDebugEnabled, []);
  const { canvasRef, trackRef, stageRef, headlineRef, debugSnapshot } = useFrameSequence(debugEnabled);

  return (
    <div ref={trackRef} className={styles.track} style={{ height: `${TRACK_VH}vh` }}>
      <div ref={stageRef} className={styles.stage}>
        <canvas ref={canvasRef} className={styles.canvas} />
        <div ref={headlineRef} className={styles.headline}>
          {HEADLINE_TEXT}
        </div>
      </div>
      {debugSnapshot && <DebugHud snapshot={debugSnapshot} />}
    </div>
  );
};

export default DnaHub;
